// import { useEffect, useRef } from "react";
// import { useDispatch } from "react-redux";
// import { INotification } from "../../store/reducers/notificationSlice";
// import { addNotification } from "../../store/reducers/notificationSlice";
// import { getWebSocketUrl } from "../../helpers/common";

// const MAX_RECONNECT_ATTEMPTS = 5;
// const RECONNECT_DELAY = 3000; // 3 seconds

// export default function useNotificationWebSocket()
// {
//   const dispatch = useDispatch();
//   const wsRef = useRef<WebSocket | null>(null);
//   const reconnectAttemptsRef = useRef(0);
//   const reconnectTimeoutRef = useRef<NodeJS.Timeout | null>(null);

//   useEffect(() =>
//   {
//     let isMounted = true;

//     async function getUserId(): Promise<string>
//     {
//       const res = await fetch("/api/whoami");
//       if (!res.ok) throw new Error("whoami failed");

//       const data = await res.json();
//       return data.userId;
//     }

//     const connect = () =>
//     {
//       if (reconnectAttemptsRef.current >= MAX_RECONNECT_ATTEMPTS)
//       {
//         console.warn("[useNotificationWebSocket] Max reconnection attempts reached");
//         return;
//       }

//       const wsUrl = getWebSocketUrl();
//       console.log(`[useNotificationWebSocket] Attempting to connect to: ${wsUrl} (attempt ${reconnectAttemptsRef.current + 1})`);

//       const ws = new WebSocket(wsUrl);
//       wsRef.current = ws;

//       ws.onopen = () =>
//       {
//         if (isMounted)
//         {
//           console.log("[useNotificationWebSocket] WebSocket connection established successfully");
//           reconnectAttemptsRef.current = 0; // Reset on successful connection
//           // Note: Not sending any data to server; server should push notifications
//         }
//       };

//       ws.onmessage = (event) =>
//       {
//         try
//         {
//           const data = JSON.parse(event.data);
//           console.log("[useNotificationWebSocket] Message received:", data);

//           // Handle both single notification and array of notifications
//           const notificationsArray = Array.isArray(data) ? data : [data];

//           notificationsArray?.filter((itemF: any) => itemF?.message).forEach((notif: any) =>
//           {

//             console.log(notif, 'notif');
//             // Ensure notification has required fields and defaults
//             const notification: INotification = {
//               id: notif.id,
//               title: notif.title ?? notif.message,
//               message: notif.message,
//               createAt: notif.time ?? new Date().toISOString(),
//               read: false,
//               tags: notif.tags || [],
//             };

//             // Dispatch to Redux store
//             dispatch(addNotification(notification));

//             // Show browser native notification
//             showBrowserNotification(notification);
//           });
//         } catch (error)
//         {
//           console.error("[useNotificationWebSocket] Failed to parse message:", error);
//         }
//       };

//       ws.onerror = (error) =>
//       {
//         console.error("[useNotificationWebSocket] WebSocket error:", error);
//         // Error event doesn't necessarily mean connection is closed yet
//       };

//       ws.onclose = (event) =>
//       {
//         if (isMounted)
//         {
//           console.log("[useNotificationWebSocket] WebSocket closed:", {
//             code: event.code,
//             reason: event.reason,
//             wasClean: event.wasClean,
//             type: event.type,
//             url: wsUrl,
//           });

//           // Interpret close code per RFC 6455
//           const closeReasons: Record<number, string> = {
//             1000: "Normal closure",
//             1001: "Endpoint going away",
//             1002: "Protocol error",
//             1003: "Unsupported data",
//             1005: "No status received",
//             1006: "Abnormal closure",
//             1007: "Invalid message data",
//             1008: "Policy violation",
//             1009: "Message too big",
//             1010: "Mandatory extension",
//             1011: "Internal server error",
//             1012: "Service restart",
//             1015: "TLS handshake",
//           };
//           const reasonText = closeReasons[event.code] || "Unknown";
//           console.log(`[useNotificationWebSocket] Close code ${event.code} (${reasonText})`);

//           wsRef.current = null;

//           // Attempt to reconnect if not a clean close (or if it was unexpected)
//           if (!event.wasClean && reconnectAttemptsRef.current < MAX_RECONNECT_ATTEMPTS)
//           {
//             reconnectAttemptsRef.current++;
//             console.log(`[useNotificationWebSocket] Reconnecting in ${RECONNECT_DELAY}ms...`);
//             reconnectTimeoutRef.current = setTimeout(() =>
//             {
//               connect();
//             }, RECONNECT_DELAY);
//           } else if (event.wasClean)
//           {
//             console.log("[useNotificationWebSocket] Clean closure, no reconnection needed");
//           }
//         }
//       };
//     };

//     // Start connection
//     connect();

//     // Cleanup on unmount
//     return () =>
//     {
//       isMounted = false;
//       if (reconnectTimeoutRef.current)
//       {
//         clearTimeout(reconnectTimeoutRef.current);
//       }
//       if (wsRef.current)
//       {
//         wsRef.current.close(1000, "Component unmounting");
//       }
//     };
//   }, [dispatch]);
// }

// // Function to show browser native notification
// async function showBrowserNotification(notification: INotification)
// {
//   // Check if Notification API is supported
//   if (!("Notification" in window))
//   {
//     console.warn("[useNotificationWebSocket] Browser does not support notifications");
//     return;
//   }

//   // Request permission if not granted (only in secure contexts)
//   if (Notification.permission === "default")
//   {
//     try
//     {
//       const permission = await Notification.requestPermission();
//       if (permission !== "granted")
//       {
//         console.warn("[useNotificationWebSocket] Notification permission not granted");
//         return;
//       }
//     } catch (error)
//     {
//       console.error("[useNotificationWebSocket] Failed to request notification permission:", error);
//       return;
//     }
//   }

//   // Show notification if permission granted
//   if (Notification.permission === "granted")
//   {
//     try
//     {
//       const browserNotification = new Notification(notification.title, {
//         body: notification.message || "",
//         icon: "/logo.png",
//         tag: notification.id.toString(),
//         requireInteraction: false,
//       });

//       // Focus window when notification is clicked
//       browserNotification.onclick = () =>
//       {
//         window.focus();
//         browserNotification.close();
//       };

//       console.log("[useNotificationWebSocket] Browser notification shown");
//     } catch (error)
//     {
//       console.error("[useNotificationWebSocket] Failed to show browser notification:", error);
//     }
//   }
// }

import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { INotification, addNotification } from "../../store/reducers/notificationSlice";
import { getStaticConfigs, isAuthenticated } from "../../helpers/common";
import { RootState } from "../../store/store";

const MAX_RECONNECT_ATTEMPTS = 5;
const RECONNECT_DELAY = 3000;

/**
 * Parse the inner notification payload that may carry the real message + tags.
 * BE sends it either as a plain string, valid JSON, or a Python-style dict
 * string using single quotes: {'message': '...', 'tags': ['order/...']}
 */
const parseInnerPayload = (raw: any): { message: string; tags: string[] } =>
{
  if (raw === undefined || raw === null) return { message: "", tags: [] };
  if (typeof raw !== "string") return { message: String(raw), tags: [] };

  const trimmed = raw.trim();

  // Plain string (not an object literal) → use as-is
  if (!trimmed.startsWith("{")) return { message: raw, tags: [] };

  // Try strict JSON first (double-quoted)
  try
  {
    const obj = JSON.parse(trimmed);
    if (obj && typeof obj === "object")
    {
      return {
        message: obj.message ?? raw,
        tags: Array.isArray(obj.tags) ? obj.tags : [],
      };
    }
  } catch
  {
    // fall through to python-dict parsing
  }

  // Python-style dict with single quotes → extract message + tags via regex
  let message = raw;
  let tags: string[] = [];

  const msgMatch = trimmed.match(/'message'\s*:\s*'((?:[^'\\]|\\.)*)'/);
  if (msgMatch) message = msgMatch[1].replace(/\\'/g, "'");

  const tagsMatch = trimmed.match(/'tags'\s*:\s*\[([^\]]*)\]/);
  if (tagsMatch)
  {
    tags = tagsMatch[1]
      .split(",")
      .map((s) => s.trim().replace(/^['"]|['"]$/g, ""))
      .filter(Boolean);
  }

  return { message, tags };
};

// =====================
// API: get user info
// =====================
async function getUserId(): Promise<string>
{
  const staticConfigs = await getStaticConfigs();
  const res = await fetch(`${staticConfigs.REACT_APP_API_KARATOS}/sessions/whoami`, {
    method: "GET",
    credentials: "include",
  });

  if (!res.ok)
  {
    throw new Error("Failed to fetch whoami");
  }

  const data = await res.json();
  return data?.identity?.id;
}

// =====================
// WS URL builder
// =====================
async function getWebSocketUrl(channel: string | undefined)
{
  try
  {

    const staticConfigs = await getStaticConfigs();



    if (staticConfigs.REACT_APP_WEBSOCKET_URL && channel)
    {
      return `${staticConfigs.REACT_APP_WEBSOCKET_URL}/${channel}/ws`;
    }
  } catch (e)
  {
    console.warn("[getWebSocketUrl] error:", e);
  }

}

// =====================
// Browser notification
// =====================
async function showBrowserNotification(notification: INotification)
{
  if (!("Notification" in window)) return;

  if (Notification.permission === "default")
  {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return;
  }

  if (Notification.permission !== "granted") return;

  try
  {
    const n = new Notification(notification.title, {
      body: notification.message || "",
      icon: "/logo.png",
      tag: String(notification.id),
    });

    n.onclick = () =>
    {
      window.focus();
      n.close();
    };
  } catch (err)
  {
    console.error("Notification error:", err);
  }
}

// =====================
// Hook
// =====================
export default function useNotificationWebSocket()
{
  const dispatch = useDispatch();
  // Fetched once after login (see App.tsx) and preferred over config.json's
  // static REACT_APP_TOPIC_NOTI_AGENT.
  const notiAgentTopic = useSelector(
    (state: RootState) => state.appCommonSlice.notiAgentTopic,
  );

  const wsRef = useRef<WebSocket | null>(null);
  const reconnectAttempts = useRef(0);
  const reconnectTimeout = useRef<NodeJS.Timeout | null>(null);
  const isConnecting = useRef(false);
  const isMounted = useRef(true);

  useEffect(() =>
  {
    isMounted.current = true;

    const connect = async () =>
    {
      if (!isMounted.current) return;
      // Don't touch any API (whoami / WS) until the user is authenticated.
      if (!isAuthenticated()) return;
      if (isConnecting.current) return;
      if (reconnectAttempts.current >= MAX_RECONNECT_ATTEMPTS)
      {
        console.warn("[WS] Max reconnect attempts reached");
        return;
      }

      isConnecting.current = true;

      try
      {
        const staticConfigs = await getStaticConfigs();

        // OAUTH2: subscribe by configured topic — prefer the value fetched
        // from the backend after login, falling back to config.json's static
        // value only if that hasn't resolved yet.
        // Other methods (e.g. COOKIES): resolve the user id via whoami.
        const channel =
          staticConfigs?.REACT_APP_AUTHENTICATION_METHOD === "OAUTH2"
            ? notiAgentTopic || staticConfigs?.REACT_APP_TOPIC_NOTI_AGENT
            : await getUserId();

        const wsUrl = await getWebSocketUrl(channel);

        console.log("[WS] Connecting:", wsUrl);

        if (wsUrl)
        {
          const ws = new WebSocket(wsUrl);
          wsRef.current = ws;

          ws.onopen = () =>
          {
            console.log("[WS] Connected");
            reconnectAttempts.current = 0;
            isConnecting.current = false;
          };

          ws.onmessage = (event) =>
          {
            try
            {
              const data = JSON.parse(event.data);
              const list = Array.isArray(data) ? data : [data];

              list
                .filter((x: any) => x?.message)
                .forEach((notif: any) =>
                {
                  const rawMessage = notif.message;
                  let resolvedMessage = rawMessage;
                  let resolvedTitle = notif.title;
                  let resolvedTags: string[] = Array.isArray(notif.tags)
                    ? notif.tags
                    : [];

                  try
                  {
                    const parsed = JSON.parse(rawMessage);
                    if (parsed && typeof parsed === 'object')
                    {
                      resolvedTitle = resolvedTitle ?? parsed.title;

                      // parsed.message can be a plain string OR a nested payload
                      // carrying the real message + tags
                      const inner = parseInnerPayload(parsed.message ?? rawMessage);
                      resolvedMessage = inner.message;
                      if (inner.tags.length > 0) resolvedTags = inner.tags;
                    }
                  } catch
                  {
                    // not JSON, use as-is
                  }

                  // notif.time from socket is Unix seconds (10 digits) → convert to ms
                  const createAt = typeof notif.time === "number"
                    ? new Date(notif.time * 1000).toISOString()
                    : notif.time ?? new Date().toISOString();

                  const notification: INotification = {
                    id: notif.id,
                    title: resolvedTitle ?? resolvedMessage,
                    message: resolvedMessage,
                    createAt,
                    read: false,
                    tags: resolvedTags,
                  };

                  dispatch(addNotification(notification));
                  showBrowserNotification(notification);
                });
            } catch (err)
            {
              console.error("[WS] parse error:", err);
            }
          };

          ws.onerror = (err) =>
          {
            console.error("[WS] error:", err);
          };

          ws.onclose = (event) =>
          {
            console.log("[WS] closed:", event.code, event.reason);

            wsRef.current = null;
            isConnecting.current = false;

            if (!isMounted.current) return;

            const shouldReconnect =
              !event.wasClean &&
              reconnectAttempts.current < MAX_RECONNECT_ATTEMPTS;

            if (shouldReconnect)
            {
              reconnectAttempts.current++;

              reconnectTimeout.current = setTimeout(() =>
              {
                connect();
              }, RECONNECT_DELAY);
            }
          };
        }


      } catch (err)
      {
        console.error("[WS] connect failed:", err);
        isConnecting.current = false;

        reconnectAttempts.current++;

        reconnectTimeout.current = setTimeout(() =>
        {
          connect();
        }, RECONNECT_DELAY);
      }
    };

    connect();

    return () =>
    {
      isMounted.current = false;
      isConnecting.current = false;

      if (reconnectTimeout.current)
      {
        clearTimeout(reconnectTimeout.current);
      }

      if (wsRef.current)
      {
        wsRef.current.close(1000, "unmount");
      }
    };
    // Re-run once notiAgentTopic resolves (fetched after login) so the socket
    // reconnects on the real topic instead of staying on the config.json fallback.
  }, [dispatch, notiAgentTopic]);
}
